import React, { FC, useState } from 'react';
import classNames from 'classnames';
import Breakpoints from '@/common/constants/breakpoints';
import Office, { OfficeInfo } from '@/pages/ContactUsPage/components/Location/Office/Office';
import { ReactComponent as ArrowIcon } from '@/assets/icons/arrow.svg';
import grid from '@/common/css/grid.module.scss';
import key from 'weak-key';
import styles from './Location.module.scss';

export interface LocationProps {
  location: string;
  offices: OfficeInfo[];
}

interface LocationComponentProps extends LocationProps {
  isOpenByDefault?: boolean;
  onEmailClick: (officeName: string) => void;
}

const Location: FC<LocationComponentProps> = ({
  location, offices, isOpenByDefault, onEmailClick,
}: LocationComponentProps) => {
  const [isOpen, setIsOpen] = useState(!!isOpenByDefault);

  const toggleContent = (): void => {
    const viewportWidth = window.innerWidth;
    if (viewportWidth < Breakpoints.sm) {
      setIsOpen((prevIsOpen) => !prevIsOpen);
    }
  };

  return (
    <div className={classNames(styles.container, !isOpen && styles.isClosed)}>
      <div
        className={styles.title}
        onClick={toggleContent}
      >
        {location}
        <ArrowIcon className={styles.titleIcon} />
      </div>
      <div className={classNames(grid.row, styles.contentContainer)}>
        {offices?.map((office) => (
          <Office key={key(office)} onEmailClick={onEmailClick} {...office} />
        ))}
      </div>
    </div>
  );
};

export default Location;
